export default function Icon3() {
    return (
        <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="45" cy="45" r="43.5" stroke="black" strokeWidth="3" />
            <line x1="10.8652" y1="16.8514" x2="78.3652" y2="73.5514" stroke="black" strokeWidth="3" />
        </svg>
    );
}
